var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clientOptions.length)?_c('form',{staticClass:"investments-options-form"},[_c('field-box',{attrs:{"name":"intranet_id","type":"select","options":_vm.clientOptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }